import { Hero, TrustStrip, HowSteps } from "../components/home/HeroSections";
import { SchoolLevels, FeaturedLessons, Formats, TeacherBanner, Testimonials } from "../components/home/ContentSections";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <TrustStrip />
      <HowSteps />
      <SchoolLevels />
      <FeaturedLessons />
      <Formats />
      <TeacherBanner />
      <Testimonials />
    </div>
  );
}
